// @flow
import { Button } from 'antd'
import BuilderSideMenuSettings from 'pages/Components/BuilderSideMenuSettings'
import { setName } from 'pages/Slices/packetSlice'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import Heading from 'ui/atoms/Heading'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'
import TextField from 'ui/molecules/TextField'

import { useDeletePackets } from '@/queries/packets/useDeletePackets'
import { ZentakeContext } from '@/utils/ZentakeContext'

function PacketSideMenu(): React.Node {
  const { name, id } = useSelector((state) => state.packet)
  const { setAlertConfig, setGlobalLoading } = React.useContext(ZentakeContext)
  const { deletePacket } = useDeletePackets()

  const dispatch = useDispatch()
  const onChange = React.useCallback(
    (value) => {
      dispatch(setName(value))
    },
    [dispatch]
  )
  const history = useHistory()
  const settingsActive = history.location.pathname.includes('settings')

  const showDeleteConfirmation = async () =>
    new Promise((resolve) =>
      setAlertConfig({
        title: 'Are you sure you want to permanently delete this packet?',
        description: `Packet name: ${name}`,
        buttons: [
          {
            title: 'Delete',
            style: 'primary',
            danger: true,
            onPress: () => resolve(true),
          },
          {
            title: 'Cancel',
            onPress: () => resolve(false),
          },
        ],
        canDismiss: false,
      })
    )

  const handleDelete = async () => {
    const confirm = await showDeleteConfirmation()
    if (!confirm) return

    try {
      setGlobalLoading(true)
      await deletePacket(id)
      history.push('/packets')
      setGlobalLoading(false)

      toast.success(`The packet has been deleted.`)
    } catch (error) {
      toast.error('An error occurred while deleting the packet.')
    }
  }

  if (settingsActive) return <BuilderSideMenuSettings resourceType="packet" />

  return (
    <Space>
      <Heading>Packet</Heading>
      <TextField label="Packet Name" onChange={onChange} value={name || ''} />
      <Text>Instructions:</Text>
      <div>
        <Text $light>1. Name packet</Text>
        <Text $light>2. Add forms to new packet</Text>
        <Text $light>3. Adjust forms to desired order</Text>
        <Text $light>4. Save</Text>
      </div>
      {id ? (
        <Button
          danger
          className="mt-6 w-full focus:outline-none"
          onClick={handleDelete}
          type="primary"
        >
          Delete Packet
        </Button>
      ) : null}
    </Space>
  )
}

export default PacketSideMenu
